import { render } from "./IndexComponent.vue?vue&type=template&id=504198f2&scoped=true"
import script from "./IndexComponent.vue?vue&type=script&lang=js"
export * from "./IndexComponent.vue?vue&type=script&lang=js"

import "./IndexComponent.vue?vue&type=style&index=0&id=504198f2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-504198f2"

export default script